<template>
  <div class="spinner">
    <div class="loader"></div>
  </div>
</template>

<style>
.spinner {
  width: 100px;
  height: 100px;
  margin: auto;
}
.loader {
  margin: 9px auto;
  width: 23px;
  height: 23px;
  border: 2px solid #212529;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
